import axios from 'axios';
import { cachetime } from '../config';

const PAGE_SIZE = 10;

export default function() {
  return {
    namespaced: true,
    state: {
      filter: {},
      search: {
        locale: '',
        award: '',
        keyword: '',
        resultCount: 0,
        results: []
      },
      agencies: {},
      __updatedAt: {},
    },
    mutations: {
      RESET_SEARCH(state, {award, keyword, locale}) {
        state.search = {
          award, keyword, locale,
          resultCount: 0,
          results: []
        }
      },
      REFRESH_SEARCH_RESULT(state, { resultCount }) {
        state.search = {
          ...state.search,
          resultCount,
          results: Array.apply(null, Array(resultCount))
        }
      },
      UPDATE_SEARCH_RESULT(state, { page, results }) {
        const START_IDX = (page - 1) * PAGE_SIZE;
        results.forEach((el, idx) => {
          state.search.results[START_IDX + idx] = {
            ...el
          };
        });
      },
      UPDATE_AGENCY(state, { data, id, locale }) {
        let allAgencies = state.agencies[id] || {};
        state.agencies = {
          ...state.agencies,
          [id]: {
            ...allAgencies,
            [locale]: {
              ...data,
              __updatedAt: Date.now()
            }
          }
        }
      },
    },
    actions: {
      SEARCH_AGENCY({ state, commit }, { award='', 
        keyword='', page=1, locale='en' 
      }) {
        if (award != state.search.award 
          || keyword != state.search.keyword 
          || locale != state.search.locale
        ) {
          commit('RESET_SEARCH', { award, keyword, locale })
        } else if (!state.search.results.slice(PAGE_SIZE * (page - 1), PAGE_SIZE * page).some(e => e == null)) {
          return ;
        }

        return axios.get(encodeURI(`/api/travelagency?lang=${locale}&award=${award}&keyword=${keyword}&page=${page}&pagesize=${PAGE_SIZE}`))
          .then((res) => {
            let { page, resultCount=0, results=[]} = res.data;
            if (resultCount != state.search.resultCount) {
              commit('REFRESH_SEARCH_RESULT', { resultCount });
            }
            
            if (results.length > 0) {
              commit('UPDATE_SEARCH_RESULT', { page, results });
            }
          }).catch(err => console.log(err));
      },
      FETCH_AGENCY({ state, commit }, { id='', locale='en' }) {
        if (state.agencies[id]
          && state.agencies[id][locale]
          && state.agencies[id][locale].__updatedAt
          && Date.now() - state.agencies[id][locale].__updatedAt < cachetime 
        ) {
          return ;
        }

        return axios.get(encodeURI(`/api/travelagency/${id}`))
          .then((res) => {
            let { data = {} } = res;
            if ("branches" in data) {
              data.subsights = [...data.branches.map(branch => {
                const { gallery, awards, coordinate, ...b } = branch;

                const awardAsessmentYears = [
                  // ['xxx', [2019, 2020]],
                  // ['xxxx', [2022]],
                  // ...
                ];
                const awardRemarks = [];

                if (awards) {
                  awards.forEach(a => {
                    // if (!a.icon) {
                    //   a.icon = a.value == 1 
                    //     ? 'fa-fw fas fa-file-certificate' 
                    //     : 'fa-fw fas fa-trophy-alt';
                    // }
                    if (a.remark) {
                      awardRemarks.push(a.remark);
                    }
                  })

                  const awardsWithValidity = awards.filter(a => Array.isArray(a.validity) && a.validity.length > 0) || [];
                  awardsWithValidity.forEach(a => {
                    a.validity.forEach(y => {
                      const award = awardAsessmentYears.find(([awardName, asessmentYears]) => awardName === a.name);
                      if (award) {
                        if (!award[1].includes(y)) {
                          award[1].push(y);
                        }
                      } else {
                        awardAsessmentYears.push([a.name, [y]])
                      }
                    });
                  });
                }

                return {
                  name: "",
                  infos: b,
                  gallery,
                  coordinate,
                  awards,
                  awardAsessmentYears,
                  awardRemarks,
                }
              })];

              delete data.branches;
            }

            commit('UPDATE_AGENCY', {
              data,
              id,
              locale
            })
          })
      }
    },
    getters: {
      getFilter: () => (name) => {
        return {
          awards: [
            {
              name,
              value: "1",
            }
          ]
        }
      },
      getAgency: (state) => (id, locale) => {
        let data = (state.agencies[id] && state.agencies[id][locale]) 
          || {
            gallery: []
          }

        if (data.awards) {
          data.awardAsessmentYears = [
            // ['xxx', [2019, 2020]],
            // ['xxxx', [2022]],
            // ...
          ];
          data.awardRemarks = [];

          data.awards.forEach(a => {
            // if (!a.icon) {
            //   a.icon = a.value == 1 
            //     ? 'fa-fw fas fa-file-certificate' 
            //     : 'fa-fw fas fa-trophy-alt';
            // }
            if (a.remark) {
              data.awardRemarks.push(a.remark);
            }
          })

          const awardsWithValidity = data.awards.filter(a => Array.isArray(a.validity) && a.validity.length > 0) || [];
          awardsWithValidity.forEach(a => {
            a.validity.forEach(y => {
              const award = data.awardAsessmentYears.find(([awardName, asessmentYears]) => awardName === a.name);
              if (award) {
                if (!award[1].includes(y)) {
                  award[1].push(y);
                }
              } else {
                data.awardAsessmentYears.push([a.name, [y]])
              }
            });
          });

          let awardWithValidity = awardsWithValidity[0] || data.awards.find(a => Array.isArray(a.validity));
          if (awardWithValidity) {
            let {infos={}} = data;

            infos.awardValidity = awardWithValidity.validity
              .map(year => parseInt(year, 10) || 0)
              .filter(year => year > 0)
              .map(year => `${year}-${year+1}`)
              .join('; ');
          }
        }

        return data;
      }
    }
  }
}